import { jsx as s, jsxs as z } from "react/jsx-runtime";
import { useRef as q, useState as p, useCallback as A, useEffect as G } from "react";
import { T as J, f as K, h as O, g as Q, e as X, c as Y, d as Z } from "../Table-Cpj5cmWs.js";
import { c as x } from "../clsx-OuTLNxxd.js";
import { B as V } from "../Button-BDQYwrrG.js";
import { C as v } from "../ChevronUp-wZxKb-n0.js";
import "../StatsTable.css?__remix_sideEffect__";const tt = "320px",et = "600px",ot = "1025px",lt = "_isVisuallyHidden_it0fn_52",nt = "_wrapper_it0fn_64",it = "_innerWrapper_it0fn_69",at = "_hasMaxHeight_it0fn_75",st = "_captionWrapper_it0fn_78",ct = "_caption_it0fn_78",rt = "_buttonWrapper_it0fn_95",dt = "_button_it0fn_95",ht = "_table_it0fn_109",gt = "_tableHead_it0fn_115",xt = "_tableColumn_it0fn_123",ft = "_tableBody_it0fn_138",bt = "_tableRow_it0fn_142",St = "_tableCell_it0fn_145",pt = "_tableFooter_it0fn_155",yt = "_hasScrollShadowEnd_it0fn_201",mt = "_hasScrollShadowStart_it0fn_210",_t = "_hasScrollShadowTop_it0fn_219",ut = "_hasScrollShadowBottom_it0fn_228",Ht = "_hasVerticalScroll_it0fn_245",Bt = "_hasHorizontalScroll_it0fn_249",wt = "_scrollFullWidth_it0fn_253",t = {
    mobile: tt,
    "mobile-wide": "480px",
    tablet: et,
    "tablet-wide": "800px",
    desktop: ot,
    "desktop-mid": "1281px",
    "desktop-large": "1360px",
    "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
    "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
    "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
    "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
    "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
    "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
    "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
    "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
    "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
    "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
    "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
    isVisuallyHidden: lt,
    wrapper: nt,
    innerWrapper: it,
    hasMaxHeight: at,
    captionWrapper: st,
    caption: ct,
    buttonWrapper: rt,
    button: dt,
    table: ht,
    tableHead: gt,
    tableColumn: xt,
    tableBody: ft,
    tableRow: bt,
    tableCell: St,
    tableFooter: pt,
    hasScrollShadowEnd: yt,
    hasScrollShadowStart: mt,
    hasScrollShadowTop: _t,
    hasScrollShadowBottom: ut,
    hasVerticalScroll: Ht,
    hasHorizontalScroll: Bt,
    scrollFullWidth: wt
  },y = ({
    children: i,
    maxRows: e,
    caption: n,
    cellWidth: h = 60,
    className: b,
    ...W
  }) => {
    var R, E;
    const a = q(null),[c, T] = p({
        top: !1,
        bottom: !1,
        left: !1,
        right: !1
      }),[B, M] = p(!1),[d, P] = p(),m = (R = a.current) == null ? void 0 : R.getElementsByTagName("tbody")[0],S = (E = m == null ? void 0 : m.getElementsByTagName("tr")) == null ? void 0 : E.length,[L, N] = p(0),[w, D] = p(window.innerWidth <= 600),[F, j] = p(),I = A(() => {
        var l;
        if (a.current) {
          const o = a.current.getElementsByTagName("thead")[0].getElementsByTagName("th"),g = o[o.length - 1];
          let f, u;
          if (w)
          N(0), f = a.current, u = o[0];else
          {
            const H = (l = [...o].filter(
              (C) => C.dataset.pinned === "true"
            )) == null ? void 0 : l.length;
            N(H), f = o[H - 1], u = o[H];
          }
          P({ lastHeading: g, lastPinnedHeading: f, firstHeading: u }), j(o);
        }
      }, [a, w]),k = (l) => {
        if (a.current) {
          const r = a.current.scrollLeft / h,o = l === "left" ? (r === 0 ? 0 : r - 1) * h : (r + 1) * h;
          a.current.scrollLeft = o, _();
        }
      },U = ({
        wrapper: l,
        headingElements: r,
        tbody: o
      }) => {
        const g = l.getElementsByTagName("tfoot"),f = r[0].getBoundingClientRect().bottom,u = g[0].getBoundingClientRect().top,H = o.getBoundingClientRect().top,C = o.getBoundingClientRect().bottom;
        return {
          top: H < f,
          bottom: C > u
        };
      },$ = ({
        columnElements: l,
        wrapper: r
      }) => {
        const o = l.lastHeading.getBoundingClientRect().right <= r.getBoundingClientRect().right;
        let g;
        return w ? g = l.firstHeading.getBoundingClientRect().left >= l.lastPinnedHeading.getBoundingClientRect().left : g = l.firstHeading.getBoundingClientRect().left >= l.lastPinnedHeading.getBoundingClientRect().right, {
          left: !g,
          right: !o
        };
      },_ = (l = !1) => {
        if (a.current && d != null && d.lastHeading && d != null && d.firstHeading && d != null && d.lastPinnedHeading && F && m) {
          const { left: r, right: o } = $({
            wrapper: a.current,
            columnElements: d
          });
          if (M(r || o), l) {
            const { top: g, bottom: f } = U({
              wrapper: a.current,
              headingElements: F,
              tbody: m
            });
            T({
              left: r,
              right: o,
              top: g,
              bottom: f
            });
          } else
          T({
            ...c,
            left: r,
            right: o
          });
        }
      };
    return G(() => {
      const l = !!e && !!S && e < S;
      return w !== window.innerWidth <= 600 && D(window.innerWidth <= 600), I(), _(l), window.addEventListener("resize", () => _(!!e), !1), () => window.removeEventListener(
        "resize",
        () => _(l)
      );
    }, [a, e, S, window.innerWidth]), /* @__PURE__ */s(
      "div",
      {
        className: x(
          t.wrapper,
          {
            [t.hasScrollShadowTop]: c.top,
            [t.hasScrollShadowBottom]: c.bottom,
            [t.scrollFullWidth]: !c.left || !B,
            [t.hasVerticalScroll]: c.top || c.bottom,
            [t.hasHorizontalScroll]: c.left || c.right
          },
          b
        ),
        style: {
          "--maxRows": S && e && S < e ? S : e,
          "--cellWidth": `${h}px`,
          "--pinCount": L
        },
        ...W,
        children: /* @__PURE__ */z(
          "div",
          {
            onScroll: () => _(!!e),
            className: x(t.innerWrapper, {
              [t.hasMaxHeight]: e,
              [t.hasScrollShadowEnd]: B && c.right,
              [t.hasScrollShadowStart]: B && c.left
            }),
            ref: a,
            children: [
            /* @__PURE__ */z("div", { className: t.captionWrapper, children: [
              /* @__PURE__ */s("h2", { ...W, className: t.caption, children: n }),
              B && /* @__PURE__ */z("div", { className: t.buttonWrapper, "data-testid": "scroll-controls", children: [
                /* @__PURE__ */s(
                  V,
                  {
                    variant: "ghost",
                    onClick: () => k("left"),
                    disabled: !c.left,
                    "aria-label": "scroll table left",
                    className: t.button,
                    children: /* @__PURE__ */s(v, { size: "s" })
                  }
                ),
                /* @__PURE__ */s(
                  V,
                  {
                    variant: "ghost",
                    onClick: () => k("right"),
                    disabled: !c.right,
                    "aria-label": "scroll table right",
                    className: t.button,
                    children: /* @__PURE__ */s(v, { size: "s" })
                  }
                )]
              })]
            }),
            /* @__PURE__ */s(J, { className: t.table, ...W, children: i })]

          }
        )
      }
    );
  },Wt = ({
    children: i,
    className: e,
    ...n
  }) => /* @__PURE__ */s(K, { size: "s", className: x(t.tableRow, e), ...n, children: i }),Ct = ({
    children: i,
    className: e,
    pinned: n,
    justifyContent: h = "center",
    ...b
  }) => /* @__PURE__ */s(
    O,
    {
      justifyContent: h,
      "data-justify": h,
      className: x(t.tableColumn, e),
      "data-type": "heading",
      "data-pinned": n,
      ...b,
      children: i
    }
  ),zt = ({
    children: i,
    className: e,
    justifyContent: n = "center",
    pinned: h,
    ...b
  }) => /* @__PURE__ */s(
    Q,
    {
      justifyContent: n,
      "data-justify": n,
      className: x(t.tableCell, e),
      "data-highlight": !!b.highlight,
      "data-pinned": h,
      ...b,
      children: i
    }
  ),Tt = ({
    children: i,
    className: e,
    ...n
  }) => /* @__PURE__ */s(X, { ...n, className: x(t.tableFooter, e), children: i }),Nt = ({ children: i, className: e, ...n }) => /* @__PURE__ */s(Y, { ...n, className: x(t.tableHead, e), children: i }),Ft = ({ children: i, className: e, ...n }) => /* @__PURE__ */s(Z, { className: x(t.tableBody, e), ...n, children: i });
y.Row = Wt;
y.Head = Nt;
y.Body = Ft;
y.Column = Ct;
y.Cell = zt;
y.Footer = Tt;
export {
  y as StatsTable };